import React from "react";

import { Flex, Link, Svg } from "components";

// Consumers (admin pages, TermsOverlay) are not flex layouts, so the logo keeps its own bottom spacing
export const AccountLogo: React.FC = () => (
  <Flex className="margin-bottom-200">
    <Link to="https://www.klim.eco" mixpanelText="klim-logo" target="_blank">
      <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
    </Link>
  </Flex>
);
